export type PortalReviewFileKind = "screenshot" | "video";

export type PortalReviewStatus =
  | "pending"
  | "useful"
  | "not_useful"
  | "implemented";

export type PortalReviewFile = {
  boxFileId: string;
  fileName: string;
  kind: PortalReviewFileKind;
  mimeType: string;
  size: number;
};

export type PortalReview = {
  review_id: number;
  emp_id: number | null;
  emp_name: string;
  emp_role: string;
  title: string;
  message: string;
  folder_key: string;
  box_emp_folder_id: string;
  box_review_folder_id: string;
  files: PortalReviewFile[];
  status: PortalReviewStatus;
  admin_note: string | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  created_at?: string;
  updated_at?: string;
};

export const PORTAL_REVIEW_STATUS_LABEL: Record<PortalReviewStatus, string> = {
  pending: "New",
  useful: "Useful",
  not_useful: "Not useful",
  implemented: "Implemented",
};
